import { mapGetters } from "vuex"

import { LoadingSpinner } from "@/components";
import TmsPartInfo from "@/components/TruckModelSearch/TmsPartInfo.vue"
import PaginationText from "@/components/Elements/PaginationText.vue";
import Pagination from "@/components/Elements/Pagination/Pagination.vue";
import { DnRouterLink } from "@/components/Elements";
import PartSearchFacets from "@/components/SubMenus/PartSearchFacets.vue";
import { themeHelper } from "@/components/mixins/themeHelper";
import { constants } from "@/const"
import { UserSettingsService } from "@/services";
;


export default {
    computed: {
        ...mapGetters([
            "user",
            "audienceIds",
            "activeAccountId",
            "getContentItem",
            "partSearchDefaultSort",
            "collapseAllPartDescriptionsValue",
            "CurrentCategory",
            "partSearchDefaultSortValue",
            "tmsCompactViewDefaultValue"
        ]),
        numberOfPages() {
            return Math.ceil(this.totalParts / this.partsPerPage);
        }
    },
    components: {
        LoadingSpinner,
        TmsPartInfo,
        PaginationText,
        Pagination,
        PartSearchFacets,
        DnRouterLink,
    }
    ,
    mixins: [
        themeHelper
    ],
    props: {
        gridView: {
            type: Boolean,
            default: false
        },
        performingSearch: {
            type: Boolean,
            default: true
        },
        hasAltParts: {
            type: Boolean,
            default: false
        },

        totalParts: {
            type: Number,
            default: 0
        },
        totalPartPages: {
            type: Number,
            default: 0
        },
        partsPerPage: {
            type: Number,
            default: 10
        },
        initialPageNumber: {
            type: Number,
            default: 1
        },
        searchResults: {
            type: Object,
            default: {}
        },
        selectedFacets: {
            type: Object,
            default: {}
        },
        categories: {
            type: Array,
            default: []
        },

    }
    ,
    data: () => ({
        isTms: true,
        searchTerm: "",
        breadcrumbDivider: "/",
        userpartSearchDefaultSort: "",
        sortByOptions: constants.SORT_BY_OPTIONS,
        inStockFilter: false,
        pageNumber: 1,
        selectedSortTerm: "",
        gridview: false,
        compactView: false,
    }),
    async created() {
        this.pageNumber = this.initialPageNumber;
        this.performPartSearch(1);
        this.compactView = this.tmsCompactViewDefaultValue === "true" || this.tmsCompactViewDefaultValue === true
    },
    watch: {
        compactView(newVal) {
            this.$store.commit("SET_TMS_COMPACT_VIEW", newVal);
        }
    },
    methods: {
        redirectToTruckSelect() {
            this.$emit("redirectToTruckSelect");
        },
        HasAltParts(hasAltParts: boolean) {
            this.$emit("hasAltParts", hasAltParts);
        },
        UpdateFacets() {
            this.$emit("updateFacets");
        },
        performPartSearch(page: number) {
            this.pageNumber = page;
            if (this.selectedSortTerm === "") {
                // Load user default, or if there is none, default to popularity
                this.selectedSortTerm = this.partSearchDefaultSortValue === "" ? "salesVolumeDesc" : this.partSearchDefaultSortValue
            }
            this.selectedSortOption = this.sortByOptions.find(option => option.value === this.selectedSortTerm);

            this.$emit("partSearch", this.selectedSortOption?.sortKey, this.selectedSortOption?.sortDirection, this.pageNumber, this.inStockFilter)
        },
        getCategoryUrl(category: string) {
            var currentUrl = window.location.href;
            var url = new URL(currentUrl);
            var searchParams = url.searchParams;
            searchParams.set('Category', category);
            url.search = searchParams.toString();
            var result = url.pathname + url.search;
            return result;
        }

    }
}
